// number-extensions.ts

// Extend Number prototype globally
 
// Extension to add the rounding methods for numbers
(Number.prototype as any).takeUpTwoDecimalPlaces = function (): number {
  const num = this as number;
  const rounded = Math.round(num * 100) / 100;  // Round to 2 decimal places
  
  // Apply Bankers' Rounding for the .5 case
  if ((rounded * 100) % 1 === 0.5) {
    return Math.floor(rounded);  // Round down to the nearest even number
  }

  return rounded;  // Return rounded value
};

// Extension to round to a specified number of decimal places
(Number.prototype as any).toDecimalPlaces = function (digits: number): number {
  if (digits < 0) throw new Error("Decimal places must be non-negative");
  
  const num = this as number;
  const factor = Math.pow(10, digits);
  const rounded = Math.round(num * factor) / factor;

  // Apply Bankers' Rounding for the .5 case
  if ((rounded * factor) % 1 === 0.5) {
    return Math.floor(rounded * factor) / factor;  // Round down to the nearest even number
  }

  return rounded;
};
// Extend the Number prototype for bankers' rounding (round half to even)
(Number.prototype as any).roundToEven = function (): number {
  const num = this as number;
  const rounded = Math.round(num * 100) / 100;

  // If the decimal part is exactly .5, apply bankers' rounding (round to even)
  if ((rounded * 100) % 1 === 0.5) {
    return (Math.floor(rounded)); // Round down to the nearest even number
  }

  return rounded;
};